/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ElectronicDeviceSuccessResponse,
  Error,
  FursElectronicDevice,
  RegisterFursElectronicDeviceBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve all electronic devices (cash registers, POS terminals) registered for a business premise.
 * @summary List electronic devices
 */
export type listFursElectronicDevicesResponse200 = {
  data: FursElectronicDevice[]
  status: 200
}

export type listFursElectronicDevicesResponse400 = {
  data: Error
  status: 400
}

export type listFursElectronicDevicesResponse401 = {
  data: Error
  status: 401
}

export type listFursElectronicDevicesResponse403 = {
  data: Error
  status: 403
}

export type listFursElectronicDevicesResponse404 = {
  data: Error
  status: 404
}

export type listFursElectronicDevicesResponse500 = {
  data: Error
  status: 500
}

export type listFursElectronicDevicesResponseSuccess = (listFursElectronicDevicesResponse200) & {
  headers: Headers;
};
export type listFursElectronicDevicesResponseError = (listFursElectronicDevicesResponse400 | listFursElectronicDevicesResponse401 | listFursElectronicDevicesResponse403 | listFursElectronicDevicesResponse404 | listFursElectronicDevicesResponse500) & {
  headers: Headers;
};

export type listFursElectronicDevicesResponse = (listFursElectronicDevicesResponseSuccess | listFursElectronicDevicesResponseError)

export const getListFursElectronicDevicesUrl = (id: string,) => {


  

  return `/fiscalization/furs/premises/${id}/devices`
}

export const listFursElectronicDevices = async (id: string, options?: RequestInit): Promise<listFursElectronicDevicesResponse> => {
  
  return customFetch<listFursElectronicDevicesResponse>(getListFursElectronicDevicesUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Register an electronic device (cash register, POS terminal, etc.) for a business premise. Required before fiscalizing invoices from this device.
 * @summary Register electronic device
 */
export type registerFursElectronicDeviceResponse201 = {
  data: ElectronicDeviceSuccessResponse
  status: 201
}

export type registerFursElectronicDeviceResponse400 = {
  data: Error
  status: 400
}

export type registerFursElectronicDeviceResponse401 = {
  data: Error
  status: 401
}

export type registerFursElectronicDeviceResponse403 = {
  data: Error
  status: 403
}

export type registerFursElectronicDeviceResponse404 = {
  data: Error
  status: 404
}

export type registerFursElectronicDeviceResponse422 = {
  data: ValidationError
  status: 422
}

export type registerFursElectronicDeviceResponse500 = {
  data: Error
  status: 500
}

export type registerFursElectronicDeviceResponseSuccess = (registerFursElectronicDeviceResponse201) & {
  headers: Headers;
};
export type registerFursElectronicDeviceResponseError = (registerFursElectronicDeviceResponse400 | registerFursElectronicDeviceResponse401 | registerFursElectronicDeviceResponse403 | registerFursElectronicDeviceResponse404 | registerFursElectronicDeviceResponse422 | registerFursElectronicDeviceResponse500) & {
  headers: Headers;
};

export type registerFursElectronicDeviceResponse = (registerFursElectronicDeviceResponseSuccess | registerFursElectronicDeviceResponseError)

export const getRegisterFursElectronicDeviceUrl = (id: string,) => {


  

  return `/fiscalization/furs/premises/${id}/devices`
}

export const registerFursElectronicDevice = async (id: string,
    registerFursElectronicDeviceBody: RegisterFursElectronicDeviceBody, options?: RequestInit): Promise<registerFursElectronicDeviceResponse> => {
  
  return customFetch<registerFursElectronicDeviceResponse>(getRegisterFursElectronicDeviceUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerFursElectronicDeviceBody,)
  }
);}
  

/**
 * Retrieve details of a specific electronic device by ID.
 * @summary Get an electronic device
 */
export type getFursElectronicDeviceResponse200 = {
  data: FursElectronicDevice
  status: 200
}

export type getFursElectronicDeviceResponse400 = {
  data: Error
  status: 400
}

export type getFursElectronicDeviceResponse401 = {
  data: Error
  status: 401
}

export type getFursElectronicDeviceResponse403 = {
  data: Error
  status: 403
}

export type getFursElectronicDeviceResponse404 = {
  data: Error
  status: 404
}

export type getFursElectronicDeviceResponse500 = {
  data: Error
  status: 500
}

export type getFursElectronicDeviceResponseSuccess = (getFursElectronicDeviceResponse200) & {
  headers: Headers;
};
export type getFursElectronicDeviceResponseError = (getFursElectronicDeviceResponse400 | getFursElectronicDeviceResponse401 | getFursElectronicDeviceResponse403 | getFursElectronicDeviceResponse404 | getFursElectronicDeviceResponse500) & {
  headers: Headers;
};

export type getFursElectronicDeviceResponse = (getFursElectronicDeviceResponseSuccess | getFursElectronicDeviceResponseError)

export const getGetFursElectronicDeviceUrl = (id: string,) => {


  

  return `/fiscalization/furs/devices/${id}`
}

export const getFursElectronicDevice = async (id: string, options?: RequestInit): Promise<getFursElectronicDeviceResponse> => {
  
  return customFetch<getFursElectronicDeviceResponse>(getGetFursElectronicDeviceUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

